import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import SCHEMA from './event-visualisation.schema.yaml';

class EventVisualisationFeature extends AbstractVisualFeature {
    get name() {
        return 'EventVisualisation';
    }

    get configSchema() {
        return SCHEMA;
    }

    getSerializableVisualConfig() {
        const {defaultSelectedTab} = this.config;

        return {
            EventVisualisationController: {
                defaultSelectedTab: defaultSelectedTab,
            },
        };
    }
}

export const EventVisualisation = new EventVisualisationFeature(allVisuals);
